/**
 * @author      xinzhe.chai@zumper.com (Xinzhe Chai)
 * @copyright   Copyright (c) 2021, Zumper
 */

import React from 'react'
import { Link } from 'react-router-dom'

import { getSizeStyle } from '../../helpers'

import { LinkButtonProps } from './LinkButton'
import * as styles from './styles'

/**
 * @param props
 * @deprecated Please use Button from @chakra-ui/react instead
 */
export const SecondaryLinkButton = (props: LinkButtonProps) => {
  const {
    buttonStyle,
    children,
    dataTestId,
    isDisabled,
    href,
    icon,
    iconStyle,
    onClick,
    onMouseDown,
    size,
    tabIndex,
    target,
    textStyle,
    to,
    useButtonStyles,
    ...rest
  } = props

  const rel = target === '_blank' ? 'noopener noreferrer' : undefined

  const styleValue = useButtonStyles
    ? [
        styles.button,
        styles.secondaryButton,
        buttonStyle,
        size ? getSizeStyle(size) : getSizeStyle('md'),
        isDisabled && styles.disabled,
      ]
    : [styles.linkButton, isDisabled && styles.disabled]

  if (to) {
    return (
      <Link
        css={styleValue}
        data-testid={dataTestId}
        onClick={onClick}
        onMouseDown={onMouseDown}
        role="button"
        tabIndex={isDisabled ? -1 : tabIndex}
        to={to}
        {...rest}
      >
        {icon && <span css={[styles.icon, iconStyle]}>{icon}</span>}
        <span css={[styles.text, useButtonStyles && textStyle]}>{children}</span>
      </Link>
    )
  }
  return (
    <a
      css={styleValue}
      href={href ?? ''}
      onClick={onClick}
      onMouseDown={onMouseDown}
      rel={rel}
      role="button"
      tabIndex={isDisabled ? -1 : tabIndex}
      target={target}
      {...rest}
    >
      {icon && <span css={[styles.icon, iconStyle]}>{icon}</span>}
      <span css={[styles.text, useButtonStyles && textStyle]}>{children}</span>
    </a>
  )
}
